import React, { useEffect, useState } from 'react';

const ACCESSION_KEY = 'GetLabs Collection-yes';

/**
 * Asks the patient, "Was your blood drawn at home by GetLabs?".
 * The question is only displayed when the orderableItem includes the 'GetLabs Collection-yes' input field.
 *
 * This component works a little differently than other sample collection components. SampleCollectionForm does not
 * validate this field, so it is not included when building the initial form. Instead, this component initializes its
 * own state from orderableItem/gearRequisition and updates SampleCollectionForm via the provided in setForm method.
 */
const GetLabCollection = ({ orderableItem, gearRequisition, disableInputs, setForm, idPrefix }) => {
	const [formField, setFormField] = useState(null);

	/** Initialize the formField when orderableItem or gearRequisition change */
	useEffect(() => {
		if (orderableItem?.inputFields) {
			const inputField = orderableItem?.inputFields?.find((field) => field.accessionKey === ACCESSION_KEY);
			const reqField = gearRequisition?.profileSpecificFields?.find((reqField) => reqField.id === inputField?.id);
			const reqFieldValue = reqField?.value === true || reqField?.value === 'true' ? true : false;

			if (inputField) {
				setFormField({
					id: inputField.id,
					value: reqFieldValue,
					accessionKey: inputField.accessionKey
				});
			}
		}
	}, [orderableItem, gearRequisition]);

	/** Update the parent form state when formField changes */
	useEffect(() => {
		if (!formField) {
			return;
		}

		setForm((prevForm) => {
			// If the value is false and the form doesn't already have the field, don't add it
			if (!formField.value && !prevForm?.[ACCESSION_KEY]) {
				return prevForm;
			}

			return {
				...prevForm,
				[ACCESSION_KEY]: {
					value: formField.value,
					id: formField.id,
					accessionKey: ACCESSION_KEY
				}
			};
		});
	}, [formField, setForm]);

	const handleChange = (event) => {
		let value = event.target.value === 'true';
		setFormField((prevField) => ({
			...prevField,
			value: value
		}));
	};

	if (!formField) {
		return null;
	}

	const collectionName = `${idPrefix}_GetLabsCollection`;

	return (
		<div className="form-group">
			<h4 className="mt-1">Was your blood drawn at home by GetLabs?</h4>
			<div className="form-check form-check-inline">
				<input
					id={`${collectionName}_yes`}
					name={collectionName}
					type="radio"
					className="form-check-input"
					checked={formField.value}
					onChange={handleChange}
					disabled={disableInputs}
					value={true}
				/>
				<label className="form-check-label" htmlFor={`${collectionName}_yes`}>
					Yes
				</label>
			</div>
			<div className="form-check form-check-inline">
				<input
					id={`${collectionName}_no`}
					name={collectionName}
					type="radio"
					className="form-check-input"
					checked={!formField.value}
					onChange={handleChange}
					disabled={disableInputs}
					value={false}
				/>
				<label className="form-check-label" htmlFor={`${collectionName}_no`}>
					No
				</label>
			</div>
		</div>
	);
};

export default GetLabCollection;
